module.exports = __webpack_public_path__ + "components/social-footer/static/pinterest-564c0c63bb718c23cf223271f294a109.svg";